export default {
  state: {
    // 主入口标签页
    mainTabs: JSON.parse(sessionStorage.getItem("mainTabs")) || [],
    // 当前标签页名
    mainTabsActiveName: ''
  },
  mutations: {
    updateMainTabs(state, tabs) {
      sessionStorage.setItem("mainTabs", JSON.stringify(tabs));
      state.mainTabs = tabs
    },
    updateMainTabsActiveName(state, name) {
      state.mainTabsActiveName = name
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js